import { useEffect, useState } from 'react';
import { todayIso } from '../data/store/store';
import type { IsoDate } from '../domain/model';

/**
 * Today's date that moves on by itself: at midnight, and whenever the app
 * comes back (a phone left open overnight, a tab in the background), so
 * "this month" and bills due never stay on yesterday.
 */
export function useToday(): IsoDate {
  const [today, setToday] = useState(() => todayIso());
  useEffect(() => {
    const check = () => setToday((t) => (t === todayIso() ? t : todayIso()));
    let timer = 0;
    const arm = () => {
      const now = new Date();
      const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);
      timer = window.setTimeout(() => {
        check();
        arm();
      }, next.getTime() - now.getTime());
    };
    arm();
    const onVisible = () => document.visibilityState === 'visible' && check();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', check);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', check);
    };
  }, []);
  return today;
}
